import { IS_LOADING } from '@/store/types/root/actions-types';
import { CATEGORY_CREATE_REQUEST, CATEGORY_UPDATE_REQUEST, CATEGORY_DELETE_REQUEST, GET_CATEGORIES_REQUEST } from './action-types';
import {ADD_CATEGORIES_TO_LIST, ADD_CATEGORY_TO_LIST, DELETE_CATEGORY_FROM_LIST, UPDATE_CATEGORY_IN_LIST} from "./mutation-types"
import api from "@/api/api"
import showMessage from "@/utils/alert"

export default {

    [GET_CATEGORIES_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/catalogs/categories")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_CATEGORIES_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [CATEGORY_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        if(body.default_points == 0)
            delete body.default_points
        try {
            response =   await api.post("/admin/catalogs/categories", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if("created_at_epoch" in reponseBody)
                    commit(ADD_CATEGORY_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [CATEGORY_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        const lodash = require('lodash');
        let response = {}            
        let oldCategory = state.categoriesList.filter(item=>{ return item.id == body.id})
        oldCategory = oldCategory.length > 0 ? oldCategory[0] : {}
        const bodyDifference = lodash.omitBy(body, (value, key) => oldCategory[key] === value);
        try{
            response =   await api.put("/admin/catalogs/categories/" + body.id, bodyDifference)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "Category Updated."){
                    commit(UPDATE_CATEGORY_IN_LIST, {...body})
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [CATEGORY_DELETE_REQUEST]: async ({ commit }, categoryIDs)=>{
        let response = {}
        try {
            response =   await api.post("/admin/catalogs/categories/delete", {"ids": categoryIDs})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                if(reponseBody.message === "Category(s) Deleted." )
                 commit(DELETE_CATEGORY_FROM_LIST, categoryIDs)
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    }

}
